import {
  useEffect,
  useState
} from "react";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import {
  getItemLedger
} from "../../services/itemLedgerService";

export default function ItemLedger() {

  const { itemId } =
    useParams();

  const navigate =
    useNavigate();

  const [
    loading,
    setLoading
  ] = useState(true);

  const [
    ledger,
    setLedger
  ] = useState([]);

  // =========================================
  // ROUTE PARAM
  // itemId actually contains item_code
  // =========================================

  const decodedItemCode =
    decodeURIComponent(
      itemId || ""
    );

  /* =================================================
     FETCH LEDGER
  ================================================= */

  const fetchLedger =
    async () => {

      try {

        setLoading(true);

        // =====================================
        // TEMP SAFE TENANT SOURCE
        // =====================================

        const user = JSON.parse(localStorage.getItem("user") || "{}");
const companyId = user?.company_id || "";

        // =====================================
        // SST SAFE FETCH
        // =====================================

        const data =
          await getItemLedger(
            companyId,
            decodedItemCode
          );

        console.log(
          "ITEM LEDGER:",
          data
        );

        setLedger(
          Array.isArray(data)
            ? data
            : []
        );

      } catch (error) {

        console.error(
          "ITEM LEDGER PAGE ERROR",
          error
        );

        alert(
          "Failed to load item ledger"
        );

      } finally {

        setLoading(false);
      }
    };

  /* =================================================
     INITIAL LOAD
  ================================================= */

  useEffect(() => {
    if (decodedItemCode) {
      fetchLedger();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [decodedItemCode]);

  /* =================================================
     HELPERS
  ================================================= */

  const formatDate =
    (
      timestamp
    ) => {

      if (
        !timestamp?.seconds
      ) {

        return "-";
      }

      return new Date(
        timestamp.seconds * 1000
      ).toLocaleString();
    };

  const getEffectColor =
    (
      value
    ) => {

      if (value > 0) {

        return "text-green-600";
      }

      if (value < 0) {

        return "text-red-600";
      }

      return "text-gray-600";
    };

  const getMovementBadge =
    (
      movement
    ) => {

      if (
        movement?.includes(
          "GRN"
        )
      ) {

        return "bg-green-100 text-green-700";
      }

      if (
        movement?.includes(
          "ISSUE"
        )
      ) {

        return "bg-red-100 text-red-700";
      }

      if (
        movement?.includes(
          "RETURN"
        )
      ) {

        return "bg-blue-100 text-blue-700";
      }

      if (
        movement?.includes(
          "TRANSFER"
        )
      ) {

        return "bg-yellow-100 text-yellow-700";
      }

      return "bg-slate-100 text-slate-700";
    };

  /* =================================================
     LOADING
  ================================================= */

  if (loading) {

    return (

      <div className="
        p-6
        text-lg
        font-medium
      ">

        Loading Item Ledger...

      </div>
    );
  }

  /* =================================================
     HEADER DATA
  ================================================= */

  const itemName =
    ledger?.[0]?.item_name ||
    "Item";

  const itemCode =
    ledger?.[0]?.item_code ||
    decodedItemCode ||
    "-";

  /* =================================================
     UI
  ================================================= */

  return (

    <div className="
      min-h-screen
      bg-slate-100
      p-6
    ">

      <div className="
        max-w-7xl
        mx-auto
        bg-white
        rounded-2xl
        shadow
        border
        p-6
      ">

        {/* ===================================== */}
        {/* HEADER */}
        {/* ===================================== */}

        <div className="
          flex
          items-center
          justify-between
          mb-6
        ">

          <div>

            <h1 className="
              text-3xl
              font-bold
              text-slate-800
            ">

              {itemName}

            </h1>

            <div className="
              text-gray-500
              mt-1
            ">

              {itemCode}

            </div>

          </div>

          <button

            onClick={() =>

              navigate(
                "/inventory-ledger"
              )
            }

            className="
              px-4
              py-2
              rounded-lg
              bg-slate-800
              text-white
              hover:bg-slate-700
            "
          >

            Back

          </button>

        </div>

        {/* ===================================== */}
        {/* ENTRY COUNT */}
        {/* ===================================== */}

        <div className="
          mb-4
          text-sm
          text-gray-500
        ">

          Total Entries:
          {" "}
          {ledger.length}

        </div>

        {/* ===================================== */}
        {/* TABLE */}
        {/* ===================================== */}

        <div className="
          overflow-x-auto
        ">

          <table className="
            w-full
            border-collapse
          ">

            <thead>

              <tr className="
                bg-slate-900
                text-white
              ">

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Date
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Movement
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Qty
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Effect
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Balance
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Unit
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Site
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Project
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Reference
                </th>

                <th className="
                  p-3
                  text-left
                  whitespace-nowrap
                ">
                  Remarks
                </th>

              </tr>

            </thead>

            <tbody>

              {ledger.length === 0 ? (

                <tr>

                  <td
                    colSpan="10"
                    className="
                      p-6
                      text-center
                      text-gray-500
                    "
                  >

                    No ledger entries found

                  </td>

                </tr>

              ) : (

                ledger.map(

                  (
                    entry,
                    index
                  ) => (

                    <tr

                      key={
                        entry.id ||
                        `${entry.reference_id}-${index}`
                      }

                      className={`
                        border-b
                        transition-all
                        hover:bg-slate-100
                        ${
                          index % 2 === 0
                            ? "bg-slate-50"
                            : "bg-white"
                        }
                      `}
                    >

                      {/* DATE */}

                      <td className="
                        p-3
                        whitespace-nowrap
                      ">

                        {formatDate(
                          entry.created_at
                        )}

                      </td>

                      {/* MOVEMENT */}

                      <td className="
                        p-3
                        whitespace-nowrap
                      ">

                        <span
                          className={`
                            px-3
                            py-1
                            rounded-full
                            text-xs
                            font-semibold
                            ${getMovementBadge(
                              entry.movement_type
                            )}
                          `}
                        >

                          {entry.movement_type}

                        </span>

                      </td>

                      {/* QTY */}

                      <td className="
                        p-3
                        font-medium
                      ">

                        {entry.qty}

                      </td>

                      {/* EFFECT */}

                      <td
                        className={`
                          p-3
                          font-bold
                          ${getEffectColor(
                            entry.stock_effect
                          )}
                        `}
                      >

                        {entry.stock_effect > 0
                          ? "+"
                          : ""}

                        {entry.stock_effect}

                      </td>

                      {/* SST SAFE BALANCE */}

                      <td className="
                        p-3
                        font-semibold
                      ">

                        {Number(
                          entry.stock_after || 0
                        )}

                      </td>

                      {/* UNIT */}

                      <td className="p-3">

                        {entry.unit || "-"}

                      </td>

                      {/* SITE */}

                      <td className="p-3">

                        {entry.site_name || "-"}

                      </td>

                      {/* PROJECT */}

                      <td className="p-3">

                        {entry.project_name || "-"}

                      </td>

                      {/* REFERENCE */}

                      <td className="
                        p-3
                        min-w-[220px]
                      ">

                        <div className="
                          font-medium
                        ">

                          {entry.reference_type || "-"}

                        </div>

                        <div className="
                          text-xs
                          text-gray-500
                          break-all
                        ">

                          {entry.reference_id || "-"}

                        </div>

                      </td>

                      {/* REMARKS */}

                      <td className="
                        p-3
                        min-w-[250px]
                      ">

                        {entry.remarks || "-"}

                      </td>

                    </tr>
                  )
                )
              )}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}